(function () {
    'use strict';

    angular
        .module('directives.oddMinNumber', [])
        .directive('oddMinNumber', directive);

    directive.$inject = ['$compile'];

    function directive($compile) {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs) {
                var minNumber = Number(attrs.oddMinNumber);
                var min = -1000000000000000; // Min Safe Integer

                // Number('') returns 0, consider it NaN
                if (attrs.oddMinNumber.length === 0) {
                    minNumber = Number.NaN;
                }

                if (!isNaN(minNumber)) {
                    min = minNumber;
                }

                elem.removeAttr('odd-min-number');
                elem.attr('min', min);
                elem.attr('ng-min', min);
                $compile(elem)(scope);
            }
        }
    }
})();